import React from "react";
import { useTheme } from "../../hooks/useTheme";

const Sun = () => (
  <svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
    <circle cx="12" cy="12" r="4" />
    <path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" />
  </svg>
);

const Moon = () => (
  <svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9z" />
  </svg>
);

/* The markup is the same whichever theme is on: both icons are rendered and
   theme.css shows the one for <html data-theme>. The prerendered pages are
   hydrated (src/index.js), and the server can't know a visitor's stored
   theme; markup that depended on it would make React throw the page away
   and render it again. */
export const ThemeToggle = ({ className }) => {
  const { toggle } = useTheme();
  return (
    <button
      type="button"
      onClick={toggle}
      className={`ds-theme-toggle${className ? " " + className : ""}`}
      aria-label="Switch between light and dark mode"
      title="Light or dark mode"
    >
      <span className="ds-theme-icon ds-theme-icon--dark">
        <Moon />
      </span>
      <span className="ds-theme-icon ds-theme-icon--light">
        <Sun />
      </span>
    </button>
  );
};
